import React from "react";
import Logo from '../../../assets/Logo-02.png';
import FooterQR from '../../../assets/footerQR.png';
import Logo40th from '../../../assets/Logo 40th 1.png';
import Bunga from '../../../assets/Bunga.png';
import signR from '../../../assets/sign_r.png';
import signS from '../../../assets/sign_s.png';
import moment from "moment";
import Barcode from 'react-barcode';
import ReactHtmlParser from 'react-html-parser';
import 'moment/locale/id';
moment.locale('id');

export class ComponentToPrint extends React.PureComponent {
  render() {
    const numberFormat = (value) =>
      new Intl.NumberFormat("id-ID", {
        style: "currency",
        currency: "IDR",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(value);

    console.log("ini printan resep", this.props.item)


    var birthdateTimeStamp = new Date(this.props.item.TANGGAL_LAHIR);
    var cur = new Date();
    var diff = cur - birthdateTimeStamp;
    var currentAge = Math.floor(diff / 31557600000);

    var birthdateTimeStamp = new Date(this.props.item.TANGGAL_LAHIR);
    var cur = new Date();
    var diff = cur - birthdateTimeStamp;
    var currentAge = Math.floor(diff / 31557600000);
    var word1 = this.props.item.NAMA_DOKTER.length;
    var word1Length = '';

    if (word1 > 46) {
      word1Length = '1.8vw';
    } else if (word1 <= 46 && word1 >= 34) {
      word1Length = '2.5vw';
    } else {
      word1Length = '3vw';
    }

    var word2 = this.props.item.SIP.length;
    var word2Length = '';

    if (word2 > 46) {
      word2Length = '1.8vw';
    } else if (word2 <= 46 && word2 >= 30) {
      word2Length = '2.5vw';
    } else {
      word2Length = '3vw';
    }


    return (
      <div
        className='hide-print'
      >
        <div
          className="container-fluid"
          style={{
            // maxWidth: "1240px",
            // maxHeight: "874px",
            // backgroundImage: 'url(' + { Bunga } + ')',
            // backgroundPosition: 'center',
            // backgroundRepeat: 'no-repeat',
            // backgroundSize: 'cover',

          }}
        >
          <div id="ui-view" data-select2-id="ui-view">
            <div>
              <div className="card" >
                {/* <div className="card-header">Invoice
      <strong>#BBB-10010110101938</strong>
      </div> */}
                <div className="card-body">

                  <div className="row"
                    style={{
                      // border: "0.5px solid #707070",
                      marginTop: '20px',
                      // marginBottom: 10
                    }}>

                    <div className="col-4"
                      // style={{ border: '1px solid red' }}
                    >
                      <table
                      // style={{ width: '100%' }}
                      >
                        <tbody>
                          <tr>
                            <td>
                              <img
                                src={Logo}
                                width="100%"
                                alt="Logo"
                                style={{
                                  // padding: 20,
                                  // paddingTop: 20,
                                  // display: "block",
                                }}
                              />
                            </td>
                          </tr>



                        </tbody>
                      </table>
                    </div>

                    <div className="col-8"
                    // style={{ width: "100%" }}
                    // style={{ border: '1px solid red' }}
                    >
                      <div style={{
                        // float: "right",
                        fontFamily: "Montserrat",
                        marginRight: '24px'
                        // fontSize: "14px",
                      }}>

                        <table style={{
                          float: "right",
                          // border: '1px solid blue'
                        }}>
                          <tbody>

                            <tr>
                              <td>
                                <div style={{
                                  width: '100%',
                                  // border: '1px solid black',
                                  fontSize: word1Length,
                                  margin: '20px',
                                  textAlign: 'right',
                                  marginTop: '-2px',
                                  fontWeight: 'bold'
                                }}>
                                  {this.props.item.NAMA_DOKTER}
                                </div>
                              </td>

                            </tr>
                            <tr>
                              <td>
                                <div style={{
                                  width: '100%',
                                  // border: '1px solid black',
                                  fontSize: word2Length,
                                  margin: '20px',
                                  textAlign: 'right',
                                  marginTop: '-12px'
                                }}>
                                  SIP : NO.{this.props.item.SIP}

                                </div>
                              </td>



                            </tr>

                          </tbody>
                        </table>


                      </div>
                    </div>


                  </div>

                  {/* <hr style={{ border: "0.5px solid #707070", marginTop: '0px' }} /> */}

                  <div style={{ width: '100%', borderWidth: '0.5px', borderBottom: '0.5px solid #707070' }}></div>

                  <div className="row" style={{
                    // border: "0.5px solid #707070", 
                    marginTop: '0px'
                  }}>
                    <div className="col=12" style={{
                      // border: "0.5px solid #707070",
                      margin: '0px 0px 0px 0px',
                      padding: "0px 0px 0px 0px",

                    }} >

                      {/* <hr style={{ border: "0.5px solid #707070", marginTop: '0px' }} /> */}

                      <form
                        style={{
                          padding: "0px 0px 0px 0px",
                          fontFamily: "Montserrat",
                          // margin: '0px',
                        }}
                      >

                        <div className="row mb-4">
                          <div className="col-12"
                          // style={{ border: "0.5px solid #707070", margin: '0px' }}
                          >
                            <label
                              style={{
                                lineHeight: "32px",
                                fontSize: 28,
                                textAlign: "right",
                                float: 'right',
                                margin: '10px 10px 10px 0px'
                              }}
                            >
                              {this.props.item.branch_city}, {moment(moment.utc(this.props.item.DATE_EXAM)).local().format("DD MMMM YYYY")}
                            </label>
                          </div>
                        </div>

                      </form>

                      <form
                        style={{
                          padding: "0px 20px 0px 20px",
                          fontFamily: "Montserrat",
                          marginBottom: 80

                        }}
                      >

                        {/* <div className="row mb-2">
                          <div className="col-3">
                            <label
                              style={{
                                lineHeight: "32px",
                                fontSize: 28,
                                textAlign: "left",
                              }}
                            >
                              Nama Dokter
                            </label>
                          </div>
                          <div className="col-9">
                            <label
                              style={{
                                lineHeight: "32px",
                                fontSize: 28,
                                fontWeight: "500",
                              }}
                            >
                              :{" "}{this.props.item.NAMA_DOKTER}
                            </label>
                          </div>
                        </div>

                        <div className="row mb-2">
                          <div className="col-3">
                            <label
                              style={{
                                lineHeight: "32px",
                                fontSize: 28,
                                textAlign: "left",
                              }}
                            >
                              SIP
                            </label>
                          </div>
                          <div className="col-9">
                            <label
                              style={{
                                lineHeight: "32px",
                                fontSize: 28,
                                fontWeight: "500",
                              }}
                            >
                              :{" "}{this.props.item.SIP}
                            </label>
                          </div>
                        </div> */}

                        {
                          this.props.item.CATATAN_RESEP ?

                            (JSON.parse(this.props.item.CATATAN_RESEP).map((item, index) => {
                              return <> <table style={{
                                // float: "right",
                                // border: '1px solid blue',
                                width: '100%'
                              }}>
                                <tbody>

                                  {/* <tr
                                    // style={{ border: '1px solid blue', margin: '0px' }}
                                    style={{ display: index > 0 ? 'none' : null }}
                                  >
                                    <td
                                      style={{ width: '200px', marginLeft: 40 }}
                                    >
                                      <p
                                        style={{
                                          fontFamily: "Montserrat",
                                          fontSize: "42px",
                                          fontWeight: 'bold',
                                          textAlign: 'center',
                                        }}
                                      >
                                        R/
                                      </p>

                                      <img
                                        src={signR}
                                        width="80px"
                                        alt="Logo"
                                        style={{
                                          marginLeft: 90,
                                          // padding: 20,
                                          paddingTop: 20,
                                          // display: "block",
                                        }}
                                      />

                                    </td>
                                    <td></td>
                                    <td></td>
                                  </tr> */}

                                  <tr
                                  // style={{ border: '1px solid blue', margin: '0px' }}
                                  >
                                    <td>
                                      <div
                                      // style={{ height: '150px' }}
                                      >
                                        <img
                                          src={signR}
                                          width="80px"
                                          alt="Logo"
                                          style={{
                                            marginLeft: 60,
                                            // padding: 20,
                                            paddingTop: 20,
                                            // display: "block",
                                          }}
                                        />
                                      </div>
                                    </td>
                                    <td>
                                      <p
                                        style={{
                                          fontFamily: "Montserrat",
                                          fontSize: "32px",
                                        }}
                                      >
                                        {item.r}
                                      </p>
                                    </td>
                                    <td></td>
                                  </tr>

                                  <tr
                                  // style={{ border: '1px solid blue', margin: '0px' }}
                                  >
                                    <td
                                      style={{ width: '160px' }}
                                    >
                                    </td>
                                    <td>
                                      {/* <p
                                        style={{
                                          fontFamily: "Montserrat",
                                          fontSize: "42px",
                                          fontWeight: 'bold',
                                        }}
                                      >
                                        S <span
                                          style={{
                                            fontSize: "32px",
                                            fontWeight: 'normal',
                                          }}
                                        >{item.s}</span>
                                      </p> */}

                                      <img
                                        src={signS}
                                        width="80px"
                                        alt="Logo"
                                        style={{
                                          marginLeft: '-10px',
                                          // padding: 20,
                                          // paddingTop: 20,
                                          // display: "block",
                                        }} />

                                      <span
                                        style={{
                                          fontSize: "32px",
                                          fontWeight: 'normal',
                                        }}
                                      >{item.s}</span>
                                    </td>
                                    <td></td>
                                  </tr>

                                  <tr
                                  // style={{ border: '1px solid blue', margin: '0px' }}
                                  >
                                    <td
                                    // style={{ width: '200px' }}
                                    >
                                    </td>
                                    <td>
                                      <hr style={{ border: "0.5px solid #707070", marginTop: '0px', marginLeft: '0px', marginRight: '100px' }} />
                                    </td>
                                    {/* <td> <hr style={{ border: "0.5px solid #707070", marginTop: '0px',  }} /></td> */}
                                  </tr>

                                </tbody>
                              </table>


                              </>
                              // <div style={{ width: 640, borderWidth: '0.5px', borderBottom: '0.5px solid #707070', marginLeft: 20, marginTop: 40 }}>
                              //   <p style={{ margin: '10px 0px 0px 0px', fontSize: 26 }}><span style={{ fontSize: 34 }}><b>R/</b></span> {item.r}</p>
                              //   <p style={{ margin: '0px 20px 0px 0px', fontSize: 26 }}><span style={{ fontSize: 34 }}><b>S</b></span> {item.s}</p>
                              // </div>
                            }))

                            : null
                        }

                      </form>




                      <div style={{ width: '100%', borderWidth: '0.5px', borderBottom: '0.5px solid #707070' }}></div>

                      <form
                        style={{
                          padding: "0px 20px 0px 20px",
                          fontFamily: "Montserrat",
                          marginTop: "24px",
                        }}
                      >

                        <div className="row mb-2">
                          <div className="col-3">
                            <label
                              style={{
                                lineHeight: "32px",
                                fontSize: 28,
                                textAlign: "left",
                              }}
                            >
                              Nama
                            </label>
                            {/* <p>Name</p> */}
                          </div>
                          <div className="col-9">
                            <label
                              style={{
                                lineHeight: "32px",
                                fontSize: 28,
                                fontWeight: "500",
                              }}
                            >
                              :{" "}{this.props.item.NAMA_PASIEN}
                            </label>
                          </div>
                        </div>

                        <div className="row mb-2">
                          <div className="col-3">
                            <label
                              style={{
                                lineHeight: "32px",
                                fontSize: 28,
                                textAlign: "left",
                              }}
                            >
                              Umur
                            </label>
                            {/* <p>Age</p> */}
                          </div>
                          <div className="col-9">
                            <label
                              style={{
                                lineHeight: "32px",
                                fontSize: 28,
                                fontWeight: "500",
                              }}
                            >
                              :{" "}{currentAge + " Tahun"}
                            </label>
                          </div>
                        </div>

                        <div className="row mb-2">
                          <div className="col-3">
                            <label
                              style={{
                                lineHeight: "32px",
                                fontSize: 28,
                                textAlign: "left",
                              }}
                            >
                              Berat Badan
                            </label>
                            {/* <p>Weight</p> */}
                          </div>
                          <div className="col-9">
                            <label
                              style={{
                                lineHeight: "32px",
                                fontSize: 28,
                                fontWeight: "500",
                              }}
                            >
                              :{" "}{this.props.item.O_BERAT + " Kg"}
                            </label>
                          </div>
                        </div>


                        {/* <div className="row mb-2">
                      <div className="col-4">
                        <label
                          style={{
                            lineHeight: "32px",
                            fontSize: 24,
                            textAlign: "left",
                          }}
                        >
                          TTL
                        </label>
                      </div>
                      <div className="col-8">
                        <label
                          style={{
                            fontSize: 24,
                            fontWeight: "500",
                          }}
                        >
                          :{" "}{this.props.item.TEMPAT_LAHIR != "" ? this.props.item.TEMPAT_LAHIR + ", " + moment(this.props.item.TANGGAL_LAHIR).format("DD-MM-YYYY") : moment(this.props.item.TANGGAL_LAHIR).format("DD-MM-YYYY")}
                        </label>
                      </div>
                    </div> */}

                        <div className="row mb-2">
                          <div className="col-3">
                            <label
                              style={{
                                lineHeight: "32px",
                                fontSize: 28,
                                textAlign: "left",
                              }}
                            >
                              Alamat
                            </label>
                            {/* <p>Address</p> */}
                          </div>
                          <div className="col-9">
                            <table>
                              <tr>
                                <td style={{ verticalAlign: 'top', fontSize: 28, width: 10, lineHeight: "22px", }}>
                                  <p>:</p>
                                </td>
                                <td>
                                  <label
                                    style={{
                                      lineHeight: "42px",
                                      fontSize: 28,
                                      fontWeight: "500",
                                      marginTop: '-6px',
                                      marginLeft: '4px'
                                    }}
                                  >
                                    {this.props.item.alamatPasien}
                                  </label>
                                </td>
                              </tr>

                            </table>


                          </div>
                        </div>



                      </form>



                      <div
                        className="footer fixed-bottom col-lg-12 col-sm-12 ml-auto"
                        style={{ paddingLeft: "40px", marginBottom: '40px', display: this.props.item.statusSelesai == "PERIKSA LAB" ? null : 'none' }}
                      >

                        <table style={{ width: '100%', textAlign: 'right', }} >
                          <tr>
                            <td align="center" style={{ width: '80px' }}>
                              <p style={{ textAlign: 'left', marginBottom: "0px", }}>
                                <img
                                  src={FooterQR}
                                  width="80"
                                  alt="Logo"
                                  style={{
                                    // padding: 20,
                                    // paddingTop: 20,
                                    // display: "block",
                                  }}
                                />
                              </p>
                            </td>

                            <td style={{}}>
                              <p
                                style={{
                                  fontFamily: "Montserrat",
                                  fontSize: "18px",
                                  textAlign: 'left',
                                  marginLeft: 10,
                                  marginBottom: '0px'
                                }}
                              >
                                <span style={{ fontWeight: 'bold' }}>Klinik Utama Bio Medika : </span>
                                {this.props.item.branch_alamat}
                              </p>
                              <p
                                style={{
                                  fontFamily: "Montserrat",
                                  fontSize: "18px",
                                  textAlign: 'left',
                                  marginLeft: 10,
                                  marginBottom: '0px'
                                }}
                              >
                                T {this.props.item.branch_notelp}
                              </p>
                              <p
                                style={{
                                  fontFamily: "Montserrat",
                                  fontSize: "14px",
                                  fontStyle: "italic",
                                  textAlign: 'left',
                                  marginLeft: 10,
                                  marginBottom: '0px',
                                }}
                              >
                                Silahkan scan QR untuk mendapatkan tambahan informasi mengenai lokasi dan layanan cabang kami.
                              </p>
                            </td>
                          </tr>
                        </table>
                      </div>

                    </div>
                  </div>

                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}